import { useQuery } from '@tanstack/react-query';
import supabaseClient from '@/api/supabaseClient.ts';

const useUserProfile = (userId: string | undefined, enabled: boolean = true) => {
  return useQuery({
    queryKey: ['users', userId],
    queryFn: () => getAction(userId!),
    enabled: enabled && !!userId,
  });
};

export default useUserProfile;

async function getAction(userId: string) {
  const { data, error } = await supabaseClient
    .from('users')
    .select('*')
    .eq('id', userId)
    .maybeSingle();

  if (error) throw new Error(error.message);
  return data;
}
